import styled from "styled-components";

export const List = styled.div``;

export const Row = styled.div`
  display: flex;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid ${(p) => p.theme.tokens.colors.line};
  font-family: ${(p) => p.theme.tokens.font.family};

  &:last-child {
    border-bottom: none;
  }
`;

export const Thumb = styled.div`
  width: 56px;
  height: 56px;
  flex-shrink: 0;
`;

export const Info = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Name = styled.div`
  font-weight: 800;
  font-size: 14px;
  color: ${(p) => p.theme.tokens.colors.ink};
  line-height: 1.25;
`;

export const ExtrasGroupLabel = styled.div`
  font-size: 11px;
  font-weight: 800;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 6px;
`;

export const ExtraLine = styled.div`
  font-size: 11.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  line-height: 1.4;
`;

export const Note = styled.div`
  font-size: 11.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 4px;
  font-style: italic;
`;

export const BottomLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
`;

export const Qty = styled.span`
  background: ${(p) => p.theme.tokens.colors.bg};
  border-radius: ${(p) => p.theme.tokens.radii.sm}px;
  padding: 3px 9px;
  font-weight: 800;
  font-size: 12.5px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const Price = styled.span`
  font-weight: 900;
  font-size: 14.5px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;
